module.exports = __webpack_public_path__ + "img/igluglow2.a6211516.jpg";